import React from 'react'
import { LinearProgress } from '@mui/material'
import { TextWithLinks } from '@collaborate-health/uikit'
import AudioPlayer from '@tabeeb/modules/shared/audioPlayer'
import { AnnotationResponse, AnnotationType } from '@tabeeb/contracts/main-api/swagger-main-api'
import { AnnotationTextResponse } from '@tabeeb/contracts/microservices/swagger-ai-service'
import { Text } from './AnnotationText.styles'

interface AnnotationTextProps {
  annotation: AnnotationResponse | undefined
  aiAnnotationText: AnnotationTextResponse | undefined
  loading: boolean
}

const AnnotationText: React.FC<AnnotationTextProps> = ({ annotation, aiAnnotationText, loading }) => {
  const renderText = (text: string) => (
    <TextWithLinks>
      <Text paragraph>{text}</Text>
    </TextWithLinks>
  )

  if (annotation?.Type === AnnotationType.AI) {
    return loading ? <LinearProgress /> : renderText(aiAnnotationText?.Text || '')
  }

  if (annotation?.Text) {
    return renderText(annotation.Text)
  }

  if (annotation?.Url) {
    return <AudioPlayer url={annotation.Url} />
  }

  return null
}

export default AnnotationText

